"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _propTypes2 = require("../helpers/prop-types");

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var NumberInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NumberInput, _React$Component);

  function NumberInput() {
    _classCallCheck(this, NumberInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(NumberInput).apply(this, arguments));
  }

  _createClass(NumberInput, [{
    key: "onFocus",
    value: function onFocus() {
      this.input.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          id = _this$props.id,
          name = _this$props.name,
          defaultValue = _this$props.defaultValue,
          value = _this$props.value,
          placeholder = _this$props.placeholder,
          disabled = _this$props.disabled,
          required = _this$props.required,
          minValue = _this$props.minValue,
          maxValue = _this$props.maxValue,
          autoFocus = _this$props.autoFocus,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          onKeyDown = _this$props.onKeyDown,
          onKeyUp = _this$props.onKeyUp,
          readOnly = _this$props.readOnly,
          tabIndex = _this$props.tabIndex,
          autoComplete = _this$props.autoComplete,
          props = _objectWithoutProperties(_this$props, ["id", "name", "defaultValue", "value", "placeholder", "disabled", "required", "minValue", "maxValue", "autoFocus", "onBlur", "onChange", "onFocus", "onKeyDown", "onKeyUp", "readOnly", "tabIndex", "autoComplete"]);

      return _react.default.createElement("input", _extends({
        className: disabled ? 'co--disabled' : null,
        id: id,
        name: name,
        type: "number",
        ref: function ref(el) {
          _this.input = el;
        },
        defaultValue: defaultValue,
        value: value,
        placeholder: placeholder,
        disabled: disabled,
        required: required,
        min: minValue,
        max: maxValue,
        autoFocus: autoFocus,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        readOnly: readOnly,
        tabIndex: tabIndex,
        autoComplete: autoComplete !== undefined ? autoComplete ? 'on' : 'off' : undefined
      }, (0, _getNativeProps.default)(props)));
    }
  }]);

  return NumberInput;
}(_react.default.Component);

NumberInput.propTypes = {
  id: _propTypes.string,
  name: _propTypes.string,

  /** {number} */
  value: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes2.numericString]),

  /** {number} */
  defaultValue: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes2.numericString]),
  placeholder: _propTypes.string,
  disabled: _propTypes.bool,
  required: _propTypes.bool,
  autoFocus: _propTypes.bool,
  maxValue: _propTypes.number,
  minValue: _propTypes.number,
  onValidate: _propTypes.func,
  onBlur: _propTypes.func,
  onChange: _propTypes.func,
  onFocus: _propTypes.func,
  onKeyDown: _propTypes.func,
  onKeyUp: _propTypes.func,
  readOnly: _propTypes.bool,

  /** {bool} If not used, the element will infer the autocomplete status from the browser configuration (by default is on) */
  autoComplete: _propTypes.bool,
  tabIndex: _propTypes.string
};
var _default = NumberInput;
exports.default = _default;
NumberInput.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onFocus",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "NumberInput",
  "props": {
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "value": {
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "custom",
          "raw": "numericString"
        }]
      },
      "required": false,
      "description": "{number}"
    },
    "defaultValue": {
      "type": {
        "name": "union",
        "value": [{
          "name": "number"
        }, {
          "name": "custom",
          "raw": "numericString"
        }]
      },
      "required": false,
      "description": "{number}"
    },
    "placeholder": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "required": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "autoFocus": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "maxValue": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "minValue": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "onValidate": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onBlur": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onFocus": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onKeyDown": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onKeyUp": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "readOnly": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "autoComplete": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "{bool} If not used, the element will infer the autocomplete status from the browser configuration (by default is on)"
    },
    "tabIndex": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};